import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    this.getDocs()
  }

  getDocs() {
    const url = this.data.get('url')
    const adminAuthorization = this.data.get('adminAuthToken')
    const endpointUserAuthorization = this.data.get('endpointUserAuthorization')
    const subdomain = this.data.get('subdomain')
    const xApiKey = this.data.get('xApiKey')
    const propertyUuid = this.data.get('propertyUuid')

    window.onload = () => {
      SwaggerUIBundle({
        deepLinking: true,
        dom_id: '#swagger-ui',
        showExtensions: true,
        showCommonExtensions: true,
        url: url,
        requestInterceptor:
          (request) => {
            request.headers.Admin_Authorization = adminAuthorization
            if (endpointUserAuthorization && subdomain) {
              request.headers.Authorization = endpointUserAuthorization
              request.headers.Subdomain = subdomain
            } else if (xApiKey) {
              request.headers.X_API_KEY = xApiKey
              request.headers.property_Uuid = propertyUuid
            }
            return request
          }
      });
    };
  }
}